import styled, { css } from 'styled-components';
import { colors } from 'stylesheets';
import Search from 'assets/img/search.svg';
import Download from 'assets/img/download.png';
import checked from 'assets/img/icons/checked.png';
import DatePicker from 'react-datepicker';
import Verified from 'assets/img/icons/verified.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 20px 16px 20px;
  min-height: ${({ wrapperHover }) => (wrapperHover ? '150px' : '100px')};
  height: ${({ wrapperHover }) => (wrapperHover ? '150px' : '100px')};
  transition: height 0.1s ease-out;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  ${({ isCanceled }) => (isCanceled
    ? css`
            opacity: 0.3;
          `
    : css`
            opacity: 1;
          `)}
  
`;

export const ContentInputDate = styled(DatePicker)`
  width: 90%;
  height: 42px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 10px;
  padding: 10px;
  color: ${colors.grey};
  cursor: pointer;
`;


export const ImageInput = styled.img`
  width: 23px;
  height: 23px;
  position: relative;
  bottom: 36px;
  left: 135px;
  cursor: pointer;
`;


export const ContentRow = styled.div`
  cursor: pointer;
  display: flex;
  width: 100%;
`;

export const ContentDetailsTask = styled.div`
  display: flex;
  flex-direction: column;
  width: 36%;
  height: 100%;
  padding-right: 20px;
  border-right: 1px solid #e8e8e8;

  a{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: ${({ isAdmin }) => (isAdmin ? '#3E81F7' : '#565656')};
    margin-left: 8px;
    ${({ isAdmin }) => (isAdmin
    ? `
      :hover{
        text-decoration: underline;
      }`
    : `
      pointer-events: none;
      cursor: default;
  `)}
  }
`;

export const ServiceTitleCard = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin-top: 8px;
  color: #565656;
`;

export const DateOfTask = styled.span`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;

  display: flex;
  align-items: center;

  color: #979797;
`;

export const StatusTask = styled.p`
 ${({ typeStatus }) => {
    switch (typeStatus) {
      case 'Novo pedido':
        return css`
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 16px;
          margin: 0px;
          width: auto;

          color: ${colors.info};
        `;
      case 'Novo orçamento':
        return css`
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 16px;
          margin: 0px;

          color: #2aecc9;
        `;
      case 'Pago':
      case 'Cancelado':
        return css`
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 16px;
          display: flex;
          align-items: center;
          margin: 0px;

          color: #565656;
        `;
      case 'Urgente':
        return css`
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 16px;
          display: flex;
          align-items: center;
          margin: 0px;

          color: red;
        `;
      default:
        return css`
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 11px;
          line-height: 16px;
          margin: 0px;

          color: ${colors.info};
        `;
    }
  }}
   margin-right: 8px;
`;

export const ContentPersonTask = styled.div`
  display: flex;
  flex-direction: column;
  width: 27%;
  height: 100%;
  border-right: 1px solid #e8e8e8;

  padding-right: 20px;
  padding-left: 20px;
`;

export const RequestTask = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ source }) => (source === 'company' && `background: url(${Verified}) no-repeat 0`)};
  ${({ imobSegment }) => (imobSegment && 'cursor: pointer')};
  background-size: 20px 20px;
  
  p{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    margin: 0;
    margin-left: 20px;
    color: #3E81F7;
    text-transform: capitalize;

    &:hover { 
      text-decoration-line: underline;
    }
  }
`;

export const ContentAddressTask = styled.div`
  display: flex;
  flex: 1;
  width: 25%;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  border-right: 1px solid #e8e8e8;

  padding-right: 20px;
  padding-left: 20px;
`;

export const AddressTask = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  text-align: right;
  color: #565656;
`;

export const CodeImmobile = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 17px;
  text-align: right;
  color: #979797;
  padding-right: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const ContentLengthTasks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 11%;

  padding-left: 20px;

  h1 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 8px;
    margin-top: 0px;
  }

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    margin-top: 5px;
    margin-bottom: 5px;
    color: #565656;
    text-align: center;
    span {
      font-weight: bold;
      color: #979797;
    }
  }

  h3 {
    span {
      font-family: 'Roboto', sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;

      color: #565656;
    }
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    color: #565656;
    margin-top: 23px;
  }

  h4 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    /* identical to box height */

    color: #979797;
    margin: 0;
  }
`;

export const ContentOnHover = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  padding-top: 10px;
`;

export const ContentButtonsHover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12%;
  min-width: 139px;
  height: 100%;
  padding-right: 10px;
`;

export const DetailsOfTaskButton = styled.button`
  background-color: #fcfcfc;
  background: url(${Search}) 7px center;
  background-repeat: no-repeat;
  outline: inherit;
  border: 1px solid #dedede;
  box-sizing: border-box;
  border-radius: 10px;
  height: 25px;
  width: 139px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  text-align: right;
  padding-right: 15px;

  color: #565656;
  &:hover {
    background-color: #e2e2e2;
  }
`;

export const ResumeButton = styled.button`
  background-color: #fcfcfc;
  background: url(${Download}) ${({ paddingIcon }) => paddingIcon || '5px'} center;
  background-repeat: no-repeat;
  outline: inherit;
  border: 1px solid #dedede;
  box-sizing: border-box;
  border-radius: 10px;
  height: 25px;
  width: 139px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;
  text-align: ${({ textAlign }) => textAlign || 'right'};
  padding-right: ${({ paddingRight }) => paddingRight || '10px'};

  color: #565656;
  &:hover {
    background-color: #e2e2e2;
  }
`;

export const ModalBody = styled.div`
  margin-top: 10px;
  margin-bottom: 40px;
  width: 476px;
  height: 50px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  /* or 179% */

  text-align: center;

  color: #787676;

  span {
    text-transform: uppercase;
    color: #ff6600;
    font-weight: bold;
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 50px;
`;

export const ButtonModal = styled.button`
  background: ${({ isCancel }) => (isCancel ? '#fff' : '#ff6600')};
  border-radius: 5px;
  width: ${({ isCancel }) => (isCancel ? '126px' : '228px')};
  height: 55px;
  padding: 9px 12px 9px 12px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */
  color: ${({ isCancel }) => (isCancel ? '#ff6600' : '#fff')};
  margin-left: ${({ isCancel }) => (isCancel ? '20px' : '-10px')};
  text-transform: uppercase;
  border: ${({ isCancel }) => (isCancel ? '1px solid #FF6600' : 'none')};
`;

export const ChooseResponsibility = styled.button`
  border: 1px solid ${({ actived }) => (actived ? '#ff6600' : '#DEDEDE')};
  box-sizing: border-box;
  border-radius: 10px;
  width: 80px;
  height: 20px;
  background-image: ${({ actived }) => actived && `url(${checked})`};
  background-repeat: no-repeat;
  background-color: ${({ actived }) => (actived ? '#fff' : '#FCFCFC')};
  background-position: 6px 5px;
  padding-left: ${({ padding }) => padding || '10px'};
  font-family: 'Roboto', sans-serif;
  text-transform: lowercase;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  font-size: 10px;
  line-height: 16px;
  margin-left: 7px;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')} !important;
  color: ${({ actived }) => (actived ? '#ff6600' : '#DEDEDE')};
  :focus {
    outline: 0;
  }

  span {
    text-transform: none;
  }
`;

export const ContentServiceResponsibility = styled.div`
  display: flex;
  width: 99%;
  align-items: center;
  height: 100%;
`;

export const TitleResponsibility = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  color: #565656;
  height: 100%;
  margin-right: 5px;
`;

export const ImgStyled = styled.img`
    width: ${({ width }) => (width || '41px')};
    height: ${({ height }) => (height || '41px')};
    ${({ borderRadius }) => (borderRadius && 'border-radius: 50%')};
    ${({ border }) => (border && 'border: 1px solid #eeeeee')};
    ${({ pointer }) => (pointer && 'cursor: pointer !important;')};
    ${({ pullRight }) => pullRight && `margin-left: ${pullRight}%;`};
    box-sizing: border-box;

    ${({ hover }) => (hover && ':hover { background-color: #e5e5e5;}')}
`;

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%; 
`;

export const StatusModal = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;

  color: #FF6600;

  margin-bottom: 15px;
`;

export const TaskVisitStatus = styled.div`
  display: flex;
  ${({ borderBottom }) => borderBottom && 'border-bottom: 1px solid #ECECEC;'};
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;

  height: 50px;
  margin-top: 10px;

  align-items: center;

  ${({ isActive }) => isActive && 'color: #FF6600;'};
  ${({ hover }) => hover && '&:hover { background-color: #e2e2e2;}'};
  ${({ pointer }) => pointer && 'cursor: pointer;'};
  img{
    margin-right: 12px;
  }
`;
export const ContentSheduling = styled.div`
  display: flex;
`;

export const ContentInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

export const LabelScheduled = styled.label`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  
  color: #D0D0D0;
`;

export const ConfirmScheduling = styled.button`
  background: none;
  border: none;
  outline: inherit;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #FF6600;

  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin-top: 200px;
  cursor: pointer;

  &:hover {
    background-color: #e2e2e2;
  }
`;

export const InputTime = styled.input`
  width: 90%;
  height: 40px;

  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 10px;
  padding: 10px;
`;

export const CenterContent = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AlignVisitLastContent = styled.div`
  display: flex;
  width: ${({ width }) => (width || '100%')};
  justify-content: center;
`;

export const StatusVisitStyled = styled.span`
  ${({ visitExpired }) => visitExpired && 'color:  #E80000;'};
  font-family: 'Roboto', sans-serif; 
  font-size: 10px;
  line-height: 12px;
  text-align: center;
`;

export const AlignVisit = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DividerPersonTask = styled.div`
  display: flex;
  height: 34px !important;
  width: 100%;
  justify-content: center;
  align-items: ${({ isEnd }) => (isEnd ? 'flex-end' : 'flex-start')};
  ${({ noPointer }) => noPointer && 'cursor: default !important'};
  ${({ bottomDashed }) => bottomDashed && 'border-bottom: 1px dashed #E8E8E8'};

   span {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    /* width: 100%; */
    color: #979797;
    min-width: ${({ isEnd }) => (isEnd ? '100px' : '85px')} !important;
  } 
`;

export const ManageTask = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ iAmManaging, adminTask }) => (iAmManaging || adminTask ? '13px' : '12px')};
  line-height: 18px;
  margin-bottom: 0px;
  color: ${({ isManaging }) => (isManaging ? '#565656' : '#3E81F7')};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ pointer }) => pointer && 'cursor: pointer'};
  ${({ hover }) => hover && '&:hover { text-decoration-line: underline; }'};
`;

export const TooltipClient = styled.span`
  position: relative;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  height: 140px;
  width: 320px;
  padding: 12px;
  background: #fff;
  border-radius: 4px;
  
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.17);
  cursor: default;
  z-index: 1;

  margin-top: -25px;
  
  span {  
    z-index: 12;
    position: absolute;
    left: 45%;
    top: -12px;
    width: 0;
    height: 0;
    
    border-bottom: 15px solid #fff;

    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
  }

  ${({ source }) => source === 'company' && `
    div {
      border: 1px dashed #DFDFDF;
      
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;
      justify-content: space-around;
      align-items: center;
    
      img{
        text-align: center;
        cursor: pointer;
        margin-top: 10px;
        :hover{
          opacity: 0.6;
        }
      }
    
      p{
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        margin: 10px;
        color: #A3A3A3;
        text-align: center;
      }
    }
  `};
`;

export const BadgeLabel = styled.span`
  border-radius: 12px;
  width: auto;
  height: 20px;
  padding: 2px 8px 0px 8px;
  background-color:  ${({ color }) => (color === '#30626B' ? 'rgba(48, 98, 107, 0.08)' : 'rgba(216, 52, 48, 0.08)')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;

  :hover{
    opacity: 0.8;
  }
`;

export const LabelText = styled.p`
  margin: 0;
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: ${({ color }) => color}; 
`;


export const RespPerson = styled.div`
  display: flex;
  align-items: center;
  height: 18px;
  width: auto;
  margin-right: 8px;

  img{
    width: ${({ size }) => size || '16px'};
    height: ${({ size }) => size || '16px'};
    margin-right: 8px;
  }

  p{
    margin: 0;
    color: #5B29F5;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
  }
`;
